define((require) => {
    "use strict";

    require("element-closest/browser");
});



// WEBPACK FOOTER //
// ./src/shared/util/ElementPolyfill.js